// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0d4323fc","455":"4c799b88"}[chunkId] + ".chunk.js";
};